import React from "react";
import { useState, useEffect } from "react";
import Navbar from "../components/navbar";
import HeaderCarousel from "../components/HeaderCarousel";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ButtonLink from "../components/ButtonLink.js";
// import ButtonInterview from "../components/ButtonInterview.js";
import ButtonArticle from "../components/ButtonArticle";

export default function Pressroom() {
  const [show, setShow] = useState(false);
  const [thisImage, setThisImage] = useState("");
  const test = "this is a test";
  const [press, setPress] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = (imageLink) => {
    setShow(true);
    setThisImage(imageLink);
  };
  const getData = async () => {
    try {
      const response = await fetch("data/press.json", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const data = await response.json();
      setPress(data);
      console.log("Loaded press data:", data);
    } catch (error) {
      console.error("Error fetching press data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <Navbar></Navbar>
      <div className="container content p-5 mt-4">
        <HeaderCarousel></HeaderCarousel>
        <div class="row pt-5">
          <h2>Press Room</h2>
          {/* {JSON.stringify(press)} */}
          <div className="row pt-2">
            {press?.map((item, i) => {
              if (!item) return null;

              if (item.type === "buttonlink") {
                return <ButtonLink key={item.link || i} caption={item.caption} star={!!item.star} link={item.link} />;
              }

              if (item.type === "buttonarticle") {
                return (
                  <ButtonArticle
                    key={item.link || i}
                    caption={item.caption}
                    star={!!item.star}
                    link={item.link}
                    link2={item.link2}
                  />
                );
              }

              return null;
            })}
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Woohoo, you are reading this text in a modal!
          <img src={thisImage} width="100%"></img>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <footer class="text-center text-lg-start bg-light text-muted mt-auto ">
        <div class="text-center p-4 bg-dark text-light">
          © 2023 Copyright:
          <a class="text-reset fw-bold" href="http://www.afrisecgroup.co.za/">
            Afrisec Group
          </a>
        </div>
      </footer>
    </div>
  );
}
